import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
    Container,
    Typography,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
    Box,
    Grid,
    Button,
    Breadcrumbs,
    IconButton,
    InputAdornment,
    TextField,
    darken,
    Divider
} from '@mui/material';
import { styled } from '@mui/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ArrowForwardIos, Search } from '@mui/icons-material';
import Header from 'src/components/header-external';
import Footer from 'src/components/footer-external';
import { Overlay } from 'src/styles/global';
import CustomizedSnackbars from 'src/components/material-snackbars';
import LogoMarca from 'src/images/new-logo2-cmtech.png';
import { browserHistory } from 'src/helpers/history';

const StyledTextField = styled(TextField)({
    backgroundColor: "#fff",
    borderRadius: "14px",
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    }
});

function NewsSectionPage(props) {
    const { intl } = props;
    const { sectionId } = useParams();

    const [articles, setArticles] = useState([]);
    const [sectionInfo, setSectionInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hirerId, setHirerId] = useState(null);
    const [clientportal, setClientPortal] = useState({});
    const [logoimagesrc, setLogoImageSrc] = useState('');
    const [searchvalue, setSearchValue] = useState('');
    const [openNotification, setOpenNotification] = useState(false);
    const [notificationVariant, setNotificationVariant] = useState('error');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [articlesections, setArticleSections] = useState([]);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api) {
            console.error("Falha ao carregar o serviço de Api.");
            setLoading(false);
            return;
        }

        const getHirerId = async () => {
            try {
                const result = await Api.get(`/configs/cancreateclientusersexternal`);
                if (result.data.success && result.data.data?.hirerid) {
                    setHirerId(result.data.data.hirerid);
                } else {
                    console.error(" Não foi possível obter hirerId");
                    setLoading(false);
                }
            } catch (error) {
                console.error(" Erro ao buscar hirerId:", error);
                setLoading(false);
                if (Api.kickoff) Api.kickoff(error);
            }
        };

        getHirerId();
    }, []);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api) {
            console.error("Falha ao carregar o serviço de Api.");
            setLoading(false);
            return;
        }

        const loadData = async () => {
            if (!sectionId || !hirerId) {
                return;
            }

            setLoading(true);

            try {
                const sectionResponse = await Api.get(`articles-section/parents/${sectionId}`);
                if (sectionResponse.data.success) {
                    setSectionInfo(sectionResponse.data.data);
                    setArticleSections(sectionResponse.data.data);
                }

                const articlesResponse = await Api.get(
                    `articles/paginatebyarticlesection/external/${sectionId}`,
                    {
                        params: {
                            hirerid: hirerId,
                            page: 1,
                        }
                    }
                );

                if (articlesResponse.data.success) {
                    const articlesData = articlesResponse.data.data || [];
                    setArticles(articlesData);
                } else {
                    setArticles([]);
                }

            } catch (error) {
                console.error(" Erro ao carregar dados:", error);
                setArticles([]);
                if (Api.kickoff) Api.kickoff(error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [sectionId, hirerId]);

    useEffect(() => {
        const Api = require('src/services/api').default;
        if (!Api || !hirerId) return;

        const getClientPortal = async () => {
            try {
                const result = await Api.get(`/clientportal/external/hirer/${hirerId}`);
                if (result.data && result.data.success) {
                    setClientPortal(result.data.data);

                    if (result.data.data.logoimage) {
                        getFile(result.data.data.logoimage);
                    } else {
                        const image = Api.getLoginImage();
                        if (image) {
                            getFile(image);
                        } else {
                            setLogoImageSrc(LogoMarca);
                        }
                    }
                }
            } catch (error) {
                console.error(" Erro ao buscar portal do cliente:", error);
            }
        };

        getClientPortal();
    }, [hirerId]);

    const getFile = async (image) => {
        try {
            let xhttpImage = new XMLHttpRequest();
            xhttpImage.open("GET", `${image.anonymoustoken}`, false);
            xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*');
            xhttpImage.send();
            let ImageData = JSON.parse(xhttpImage.responseText);
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                setLogoImageSrc(ImageData.data);
            }
        } catch (e) {
            console.error("Erro ao carregar imagem:", e);
        }
    };

    const handleBack = () => {
        if (props.history.length > 1) {
            browserHistory.goBack();
        } else {
            props.history.push(`/${props.match.params.lang}/client-portal-external`);
        }
    };

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const searchArticle = () => {
        props.history.push(`/${props.match.params.lang}/article-list-external`);
    };

    const closeNotification = () => {
        setOpenNotification(false);
    };

    const renderSectionsBreadCrumb = () => {
        const defaultClientColor = clientportal.defaultcolor ? clientportal.defaultcolor : null;

        if (!Array.isArray(articlesections) || articlesections.length === 0) {
            return null;
        }

        return (
            <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ArrowForwardIos fontSize="small" sx={{ color: defaultClientColor }} />}
            >
                {articlesections.map((section, index) => {
                    const isLast = index === articlesections.length - 1;

                    if (isLast) {
                        return (
                            <Typography
                                key={section.id}
                                variant="h5"
                                sx={{
                                    color: '#000',
                                    fontWeight: 'bold',
                                    cursor: 'default'
                                }}
                            >
                                {section.name}
                            </Typography>
                        );
                    } else {
                        return (
                            <Typography
                                key={section.id}
                                variant="h5"
                                sx={{
                                    cursor: "pointer",
                                    color: defaultClientColor,
                                    "&:hover": {
                                        textDecoration: "underline",
                                    }
                                }}
                            >
                                {section.name}
                            </Typography>
                        );
                    }
                })}
            </Breadcrumbs>
        );
    };


    
    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            margin: 0,
            padding: 0,
            width: '100vw',
            maxWidth: '100vw', 
            overflowX: 'hidden', 
            position: 'absolute', 
            left: 0, 
            top: 0, 
            '& *': { 
                boxSizing: 'border-box'
            }
        }}>
            <main style={{
                flex: 1,
                width: '100vw',
                backgroundColor: '#fff'
            }}>
                <Container style={{
                    maxWidth: '100vw',
                    width: '100vw',
                    margin: 0,
                    padding: 0,
                    backgroundColor: '#fff',
                    minHeight: '100vh'
                }}>
                    <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                        <Grid item container spacing={4} sx={{ backgroundColor: '#fff' }}>
                            {/* HEADER */}
                            <Header
                                intl={props.intl}
                                clientportal={clientportal}
                                calledservicesettings={clientportal.calledservicesettingsclientportals}
                                language={props.match.params.lang}
                                logoimagesrc={logoimagesrc}
                            />

                            {/* ÁREA DE BUSCA */}
                            {clientportal.enablesearch && (
                                <Grid item xs={12}>
                                    <Box style={{
                                        display: "block",
                                        width: "100vw",
                                        textAlign: "center",
                                        alignContent: "center",
                                        backgroundColor: clientportal.defaultcolor,
                                        paddingBlock: "20px"
                                    }}>
                                        <StyledTextField
                                            name="searchvalue"
                                            label={intl.formatMessage({ id: "search" })}
                                            value={searchvalue}
                                            onChange={handleChange}
                                            sx={{ width: "60vw" }}
                                            size="medium" 
                                            InputProps={{
                                                sx: { 
                                                    '& .MuiInputBase-input': {
                                                        padding: '16.5px 14px',
                                                    },
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={searchArticle}>
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            )}

                            {/* BOTÃO VOLTAR */}
                            <Grid item xs={12} container justifyContent="center">
                                <Grid item xs={10} md={8} lg={6}>
                                    {clientportal && clientportal.defaultcolor && clientportal.defaultcolor.length > 0 ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleBack}
                                            sx={{
                                                backgroundColor: clientportal.defaultcolor,
                                                color: '#fff',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    backgroundColor: darken(clientportal.defaultcolor, 0.2),
                                                },
                                            }}
                                        >
                                            {intl.formatMessage({ id: "back" })}
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleBack}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            {intl.formatMessage({ id: "back" })}
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>

                            {/* CONTEÚDO */}
                            <Grid item xs={12} container justifyContent="center" sx={{ backgroundColor: '#fff', flex: 1 }}>
                                <Grid item xs={10} md={8} lg={6}>


                                    <Box sx={{ mb: 3 }}>
                                        <Typography
                                            variant="h1"
                                            sx={{
                                                color: '#000',
                                                fontWeight: 'bold',
                                                cursor: 'default'
                                            }}
                                        >
                                            {sectionInfo && sectionInfo.length > 0
                                                ? sectionInfo[sectionInfo.length - 1]?.name
                                                : intl.formatMessage({ id: "news.section" })}
                                        </Typography>
                                        <Divider />
                                    </Box>

                                    {/* LISTA DE ARTIGOS */}
                                    <Box sx={{
                                        borderLeft: '3px solid #E53935',
                                        paddingLeft: '24px',

                                    }}>
                                        <List sx={{ p: 0 }}>
                                            {articles.length > 0 ? (
                                                articles.map(article => (
                                                    <ListItem
                                                        key={article.id}
                                                        button
                                                        component={Link}
                                                        to={`/${props.match.params.lang}/article-external/${article.id}`}
                                                        sx={{
                                                            padding: '12px 0',
                                                            textDecoration: 'none',
                                                            borderBottom: '1px solid #f0f0f0',
                                                            '&:last-child': {
                                                                borderBottom: 'none'
                                                            },
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                                '& .MuiListItemText-primary': {
                                                                    color: clientportal.defaultcolor || 'primary.main',
                                                                    textDecoration: 'underline'
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={article.title}
                                                            primaryTypographyProps={{
                                                                variant: 'body1',
                                                                color: 'text.primary',
                                                                fontWeight: 500
                                                            }}
                                                        />
                                                    </ListItem>
                                                ))
                                            ) : (
                                                <Typography variant="body1" color="text.secondary">
                                                    <FormattedMessage id="No.news.found" />
                                                </Typography>
                                            )}
                                        </List>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        
                        <Box sx={{ marginTop: 'auto' }}>
                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                setLoading={setLoading}
                            />
                        </Box>
                    </Grid>



                </Container>
            </main>
            
            {loading && (
                <Overlay>
                    <CircularProgress color='secondary' />
                </Overlay>
            )}

            
            <CustomizedSnackbars
                variant={notificationVariant}
                message={notificationMessage}
                isOpen={openNotification}
                toClose={closeNotification}
            />
        </Box>
    );
}

export default injectIntl(NewsSectionPage);